import React from "react";
import "./blogs.css";


const Ashish_Singh = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/dp/Ashish-Singh.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="Ashish"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Ashish</h2>
            <small>Tata Projects Limited</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction </h3>
            <p>
              Hi! This is Ashish, a Y19 BT-CE, currently placed in Tata Projects
              Limited (TPL). Through this blog, I share my journey from
              submitting my resume after deadline extension to securing an offer
              at TPL. <br />I am inclined towards and targeted too just civil
              core in the placements. Hence, everything that follows should be
              read with a focus on civil core only.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>JUST CORE, NOTHING ELSE</h3>
            <p>
              People have different aspirations arising from differences in
              needs, interests, and wants. It results in differences in
              priorities and life paths. I did not go with the flow and chose
              what my heart said, which is a multivariable function of factors,
              each with its own varying significance. Trying things, talking to
              friends, family, seniors, and self-contemplation helped me figure
              out the path I am moving on today.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Ashish-Singh/1.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>OPPORTUNITIES FOR CIVIL CORE IN SPO PLACEMENT DRIVE</h3>
            <p>
              From the beginning I had an inclination towards core but towards
              the end I got demotivated a lot and was compelled to look into
              non-core opportunities because of pathetic placement opportunities
              in civil core during SPO placements. But after talking to some
              fantastic seniors, some family members, and self-contemplation, I
              decided to go for core only. This time is around mid-6th semester.
              <br /> At that time, I had only a little hope for the upcoming SPO
              drive and started preparation for GATE in the summers after the
              6th semester. Due to some unforeseen personal conditions, I could
              not manage the preparation after a couple of months. I was still
              deciding whether to sit in placements or focus entirely on GATE.
              Half-heartedly, I started editing my resume but couldn't complete
              the editing before the original deadline, indicating my lack of
              motivation for placements. However, with the deadline extension, I
              finished and submitted it.
            </p>
            <p>
              Until the Y18 placements, to the best of my knowledge, Tata
              Projects Limited (TPL) used to offer the best package among civil
              core companies. I found the stipend decent, especially considering
              the initial remuneration offered to freshers in the market. While
              there were a few other companies, TPL was the only one that
              occupied my mind, and I can't even recall the names of the others.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>JUST PSUs AND TPL</h3>
            <p>
              I participated in placements primarily for TPL & PSUs. PSUs
              because our DPCs were making efforts to onboard them too this time
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>PLEASANT SURPRISE</h3>
            <p>
              To my pleasant surprise, this time a decent number of core
              companies participated, and a few offered decent packages too. I
              want to extend my gratitude to our highly motivated and dedicated
              DPC's Meet Saiya and Ajay Khatri for their efforts. Notably, this
              year marked the first-time appearance of Godrej, surpassing TPL in
              terms of CTC.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>APPLICATIONS</h3>
            <p>
              I applied in around 10 core companies. I wasn't interested in
              every application I submitted as some of them had extremely low
              packages, but the issue was that there were periods of consecutive
              days when no civil core job openings were available. So, out of
              boredom and just to have some applications out there, I would
              apply whenever I saw a core-related company posting.
              Unfortunately, this low frequency of core company openings on the
              job portal caused me to miss out on applying to some great
              opportunities, including Airbus.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>SHORTLIST AND INTERVIEW PREPARATION </h3>
            <p>
              TPL does not require candidates to take any tests; they shortlist
              applicants based on their resumes. TPL was my first interview, and
              prior to that, none of the companies I applied to had conducted
              any tests, so I cannot comment on tests. I haven't prepared for
              tests either because I knew TPL doesn't include one in their
              process and I was not looking for other companies, except PSUs
              which might take tests, but were also not sure to come.
              Additionally, I was going through the gate content, so that was
              the max I thought I could do for PSUs. So, I didn’t prepare
              anything else exclusively for tests. I was still not very
              optimistic about the placements. I was thrilled to be shortlisted
              for TPL. I thoroughly prepared my resume and standard HR
              questions.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Ashish-Singh/2.jpg"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>INTERVIEW</h3>
            <p>
              Initially, I was informed that TPL would come in slot 2.1, so I
              eagerly prepared myself, dressed in my placement suit, and eagerly
              awaited the interview. However, to my disappointment, it didn't
              happen in slot 2.1. The same thing occurred for slots 2.2 and 3.1,
              and my hope started dwindling.
            </p>
            <p>
              Then, the company's list for slot 3.2 was published, and to my
              dismay, TPL was not included. I felt all hope was lost. But
              miraculously, at the last moment, TPL was added to the list. I
              quickly dressed up, took a friend along, and rushed to Hall 12.
            </p>
            <p>
              The interviewers arrived, and my nervousness was evident from my
              looks, but I composed myself. I got my interview scheduled at the
              top. I went in, and the experience turned out to be smooth and
              seamless. The interview was both technical and HR combined. It
              started with a light discussion about the courses in my next
              semester followed by a real site-based problem.
              <br /> Later, we discussed on a couple of my projects, a couple of
              basic questions over a course they asked me to choose. In between
              I was being asked HR questions as well. It was a seamless
              discussion between us. It was not too core heavy. I barely got
              stuck anywhere, except for the site related question which also I
              answered eventually as I figured out along our discussion what I
              was expected to say. Time flew by rapidly, and before I knew it,
              the interview was over. It was about a half hour interview.
            </p>
          </div>
        </div>
        
            <div className="row blog-row">
              <div className="col-md-12">
                <h3>RESULTS</h3>
                <p>
                  From that moment until the evening when I received the call
                  confirming my selection, I remained visibly nervous and didn't
                  even change my dress, eagerly awaiting the results.
                </p>
                <p>
                  Overall, there have been many instances when I felt hopeless,
                  but the support from my family and seniors has been
                  instrumental in relieving tension and preventing the build-up
                  of pressure, enabling me to stay composed. A calm and focused
                  mind is crucial during interviews.
                </p>
              </div>
            </div>
           

           
                <div className="row blog-row">
                  <div className="col-md-12">
                    <h3>INSIGHTS & OBSERVATIONS</h3>
                    <p>
                      Based on my experience, I'll attempt to provide insights
                      into resumes & interviews (not the tests as neither I
                      prepared nor any of it happened before my TPL interview).
                    </p>
                  </div>
                </div>

                
                    <div className="row blog-row">
                      <div className="col-md-12">
                        <h3>Resume</h3>
                        <p>
                          The resume plays a pivotal role in the entire process
                          and holds immense importance as in some cases, certain
                          companies, like TPL, may shortlist candidates directly
                          for interviews solely based on the strength of their
                          resumes, without requiring additional tests.
                          Therefore, it becomes crucial to craft a
                          well-presented resume that highlights your passion for
                          civil engineering.
                          <br /> Having internships, research experiences, and
                          projects related to the core area will make your
                          resume stand out. Also, aim to maintain a decent CPI,
                          preferably above 8, for added safety. I am unaware of
                          all companies, but TPL have selected students with CPI
                          between 7 and 8 as well. It's highly advisable not to
                          let your CPI drop below 7. Things might change
                          accordingly in case there are many candidates with
                          high CPIs, I think.
                        </p>

                        <p>
                          Having positions of responsibility (POR) on your
                          resume can be beneficial as working on-site requires
                          responsible and team-oriented individuals. During my
                          own interview, there were no specific questions about
                          POR, but it's still a valuable addition in my opinion.
                          <br />
                          Include the civil courses you've taken on your resume
                          as well. There might be a few questions related to
                          these courses, as I had a few over one of the course
                          which interviewer requested me to choose during my own
                          interview.
                        </p>
                        <p>
                          I mentioned all the civil related software I used in
                          the past like Abaqus, AutoCAD, SAP2000, and civil
                          related python libraries I used in some projects
                          exclusively. So based on your discretion, do mention
                          things you find related to civil industry in addition
                          to standard things in the resume, which shows your
                          passion and commitment for civil engineering, which is
                          the needed separation from other candidates as
                          recruiters want passionate people in their company.
                        </p>
                        <p>
                          Before finalizing your resume, its recommended to get
                          it reviewed and ratified by a couple of seniors or
                          experienced individuals.
                        </p>
                      </div>
                    </div>
                    <img
                      class="blog-image-left"
                      src="placement-postulates/blogs/Ashish-Singh/4.jpg"
                    />

                    
                        <div className="row blog-row">
                          <div className="col-md-12">
                            <h3>Interview</h3>
                            <p>
                              I found the following important aspects to be
                              focused upon:
                            </p>
                            <p>
                              • Resume: A resume becomes a crucial part of your
                              core interviews. Be as thorough with your resume
                              as you can. Try to cover every possible question
                              you think could be framed upon reading your
                              resume. For projects, keep the objective,
                              methodology and the results of each one of those
                              on tips.
                            </p>
                            <p>
                              • HR Questions: Prepare standard HR questions.
                              While the questions themselves are typical, the
                              answers should be unique to you. These questions
                              does not only help the interviewer understand you
                              better but also enable you to introspect and gain
                              deeper insights into yourself.
                              <br /> By doing this, we gain clarity about the
                              role, its responsibilities, as well as our own
                              needs and desires, which, in turn, will enhance
                              our ability to convince others. To stand out from
                              other candidates who may provide generic,
                              idealistic, or memorized responses, focus on
                              preparing practical and believable answers that
                              genuinely resonate with you. Try to display your
                              passion for civil engineering, through your
                              answers.
                            </p>
                            <p>
                              • Communication: Effective communication skills
                              make a difference. It’s one thing to possess
                              knowledge, but if you cannot convey it in a manner
                              that demonstrates your understanding, it’s of less
                              use during interview. Remember, during an
                              interview, the interviewer doesn't know you
                              personally; they evaluate you based on how you
                              present yourself and communicate. Therefore, it's
                              essential to thoroughly prepare before the
                              interview, anticipate and practice all possible
                              resume-based and HR-related questions. Adequate
                              practice will smoothen your interview experience.{" "}
                              <br />
                              When you have practiced extensively, many of the
                              questions asked will likely have been rehearsed,
                              enabling you to respond with precision,
                              conciseness, and confidence. This approach will
                              increase the number of favorable responses and
                              reduce any potential stumbling in your answers.
                            </p>
                            <p>
                              • Presence of mind: The presence of mind is a
                              crucial factor that cannot be underestimated.
                              During interviews, you may encounter
                              out-of-the-box questions or practical scenarios
                              related to the field which cannot be fully
                              prepared for in advance. The panel may present you
                              with such a problem and ask about your approach to
                              resolving it.
                              <br /> These skills are vital in on-site or office
                              environments. It's crucial not to panic but to
                              tackle these situations with logic and scientific
                              thinking. By doing so, you might relate them to
                              concepts you've already studied, which shows your
                              ability to practically apply the concepts you have
                              studied.
                            </p>
                          </div>
                        </div>
                        <img
                          class="blog-image-right"
                          src="placement-postulates/blogs/Ashish-Singh/3.jpg"
                        />

                        
                            <div className="row blog-row">
                              <div className="col-md-12">
                                <h3>RISKY GAME</h3>
                                <p>
                                  It was a risky game for me. As I was
                                  interested only in a few of my applications,
                                  which were already only a few in the first
                                  place, it decreased my chances of winning
                                  drastically.
                                </p>
                                <p>
                                  For anyone aiming for civil core in SPO drive,
                                  do consider having a backup plan because of
                                  limited opportunities in terms of number of
                                  companies visiting and low package offered by
                                  most of them.
                                </p>
                              </div>
                            </div>

                            
                                <div className="row blog-row">
                                  <div className="col-md-12">
                                    <h3>FRIENDS ARE SAVIOURS</h3>
                                    <p>
                                      This placement journey is much more
                                      manageable if you are together with your
                                      friends. Verify each other’s resumes,
                                      take, and give interviews, and have each
                                      other’s back during the placement drive,
                                      as it can get seriously disappointing,
                                      demotivating, and frustrating. Be with
                                      your friends. Your friends will be the
                                      only one’s handling logistics for you when
                                      you are giving an interview, like
                                      scheduling your other interviews,
                                      submitting your resume for Walkins, etc.,
                                      which allows you to concentrate peacefully
                                      on your present one. After you secure a
                                      job, help your friends.
                                    </p>
                                    <p>
                                      And lastly, good friends, seniors, family
                                      members, or any other acquaintance you
                                      believe in are always invaluable assets.
                                    </p>
                                    <p>
                                      मैं अकेला ही चला था जानिब-ए-मंज़िल मगर लोग
                                      साथ आते गए और कारवाँ बनता गया <br />~
                                      मजरूह सुल्तानपुरी
                                    </p>
                                  </div>
                                </div>

                                <p>
                                  <ul>
                                    <li>
                                      <b>Resume:</b>{" "}
                                      <a
                                        href="https://drive.google.com/file/d/1tWBHZugWf9FGrm_gPRLXkm0BuK0WZ6b2/view?usp=sharing"
                                        className="resume-link"
                                      >
                                        [View Resume]
                                      </a>
                                    </li>
                                  </ul>
                                </p>
                              </div>
                            </div>
                      
      
  );
};

export default Ashish_Singh;
